import SkipButton from "./SkipButton";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(SkipButton);
